import EngagementButtons from '@/app/components/EngagementButtons/EngagementButtons';
import { TickList } from '@/app/components/TickList';
import specialistImage from '@/modules/HomePageV2/sections/PlacementTypeSection/assets/specialist-locum.png';
import Image from 'next/image';

import styles from './Content.module.scss';

export const LocumContent = ({ isDesktop }: { isDesktop: boolean }) => {
  return (
    <div className={styles.contentContainer}>
      <p className={styles.contentText}>
        Flexibility, higher pay, and the chance to explore diverse healthcare settings across
        Australia and New Zealand. With locuming, you choose when and where you work, and we’ll
        handle the rest.
      </p>
      <TickList
        items={[
          'Boost income with competitive rates',
          'Work across diverse settings',
          'Travel and accommodation covered',
        ]}
      />
      <EngagementButtons
        trackAction="Placement section - Locum"
        searchJobsUrl="/jobs/list?workType=Locum&page=1"
      />
      {isDesktop && (
        <div className={styles.imageContainer}>
          <Image
            src={specialistImage}
            priority={false}
            alt=""
            aria-hidden
            width={414}
            height={370}
            style={{
              maxWidth: '100%',
              height: 'auto',
            }}
          />
        </div>
      )}
    </div>
  );
};
